export const AGENT_ID = 'agentId';
export const AGENT_TYPE = 'agentType';